module.exports = __webpack_public_path__ + "static/assets/2b67db6b0c564ea8597c300f4bcb52ac.jpg";